<script>
export default {
  props: {
    menuMr: {
      type: String,
      default: ''
    },
    menuWeb: {
      type: String,
      default: ''
    },
    menuLink: {
      type: String,
      default: ''
    },
    menuIcon: {
      type: String,
      default: ''
    },
    menuText: {
      type: String,
      default: ''
    },
    menuIconCss: {
      type: String,
      default: ''
    },
    menuFontCss: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 菜單外層Css
    computedMr () {
      return this.menuMr === 'true' ? `mr-2` : ''
    },
    computedWeb () {
      return this.menuMr === 'true' ? `web-on` : ''
    },
    computedIconCss () {
      return this.menuMr === 'true' ? `menuicon` : ''
    },
    computedFontCss () {
      return this.menuMr === 'true' ? `line-h` : ''
    }
  }
}
</script>

<template>
  <div
    class="col col-lg"
    :class='[computedMr, computedWeb]'
  >
    <router-link
      class="identity-box identity-lia"
      style="text-decoration: none;"
      :to="menuLink"
    >
      <font-awesome-icon
        :icon="menuIcon"
        :class="computedIconCss"
        size="3x"
      />
      <br>
      <div
        class="menu-h4"
        :class="computedFontCss"
      >
        {{ menuText }}<br>
        <slot name="menu-eg" />
      </div>
    </router-link>
  </div>
</template>
